import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { ExamSubjectsService } from "../../../services/ExamService/SubjectService/subject.service";
import SubjectCards from "../../../shared/components/CourseComponents/SubjectCards";
import EmptyState from "../../../shared/components/EmptyState";
import PaginationComponent from "../../../shared/components/PaginationComponent";
import CourseHeader from "../../../shared/components/AppHeader/index";
import SubjectForm from "../../../shared/components/CourseComponents/SubjectForm";
const ExamSubjects = (props: any) => {
  const { examId } = props.match?.params;
  const [examSubjects, setExamSubjects] = useState<any>([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [meta, setMeta] = useState<any>();
  const [showForm, setFormVisibility] = useState(false)
  const fetchSubjects = (pageNumber: number, searchString?:string) => {
    let queryParams = `?page=${pageNumber}&exam_id=${examId}&search=${searchString || ''}`

    ExamSubjectsService.fetchExamSubjects(
      queryParams,
      (subjects: any, meta: any) => {
        setExamSubjects(subjects);
        setMeta(meta);
        console.log(subjects, meta);
      },
      (error: any) => {
        console.log(error);
      }
    );
  };
  useEffect(() => {
    fetchSubjects(1);
  }, []);
  const handleSearch = (value:string) => {
    fetchSubjects(currentPageNumber,value)
}

  const handlePageChange = (page:number) => {
    fetchSubjects(page);
    setCurrentPageNumber(page);
}
  return (
    <div className="page-view">
      <CourseHeader
        headerText="Subjects"
        handleSearch={handleSearch}
        handleHeaderAction={() => {
          setFormVisibility(true);
        }}
        buttonText="Subject"
        showBreadCrumb
      />
       <SubjectForm title="New Subject"
                         visible={showForm}
                         setVisible={setFormVisibility}
                         refreshList={fetchSubjects}
                         currentPageNumber={currentPageNumber}
                         examId={parseInt(examId)}
            />
      {examSubjects.length > 0 ? (
        <>
          <SubjectCards
            courses={examSubjects}
            refreshList={fetchSubjects}
            currentPageNumber={currentPageNumber}
            examId={examId}
          />
          <PaginationComponent
            handlePageChange={handlePageChange}
            paginationMeta={meta}
          />
        </>
      ) : (
        <EmptyState text={"No classes found."} />
      )}
    </div>
  );
};
export default withRouter(ExamSubjects);
